module.exports = __webpack_public_path__ + "static/media/css3-plain.7c6a6b60.svg";